import React from 'react';
import { connect } from 'react-redux';

import Icon from './../Icon';
import Dropdown from './../Dropdown';
import Select from './../Select';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'profile_experience';
const options = ['Not specified', 'No experience', 'Less than 1 year', '1-2 years', 'More than 2 years'];

const ExperienceDropdown = props => {
    const { value, save } = props;
    const text = value || 'Select';
    return (
        <div>
            Experience:
            <Dropdown buttonClassName="lnk-dropdown" text={text} closeAlways>
                <Select value={value} onChange={save} className="menu menu-selectable">
                    {options.map(option =>
                        <li key={option} value={option} className="menu-item">
                            {option}
                            <Icon className="svg-icon" iconName="check-empty" />
                        </li>
                    )}
                </Select>
            </Dropdown>
        </div>
    );
};

const mapStateToProps = state => ({
    value: state.user[fieldName] || options[0]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ExperienceDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/ExperienceDropdown.js